import { OWNER } from "../data/catalog";
import { Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#1E2D4A] bg-[#040914] mt-24">
    <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <h4 className="font-heading text-xl tracking-tight text-white">{OWNER.name}</h4>
        <p className="text-white/50 text-sm mt-3 leading-relaxed max-w-xs">{OWNER.tagline}</p>
      </div>
      <div className="space-y-3">
        <div className="text-xs tracking-[0.2em] uppercase text-white/40">Contact</div>
        <a href={`mailto:${OWNER.email}`} className="flex items-center gap-3 text-white/80 hover:text-white">
          <Mail className="w-4 h-4" strokeWidth={1.5} /> {OWNER.email}
        </a>
        <a href={`tel:${OWNER.phone}`} className="flex items-center gap-3 text-white/80 hover:text-white">
          <Phone className="w-4 h-4" strokeWidth={1.5} /> {OWNER.phone}
        </a>
        <div className="flex items-center gap-3 text-white/80">
          <MapPin className="w-4 h-4" strokeWidth={1.5} /> {OWNER.coverage}
        </div>
      </div>
      <div>
        <div className="text-xs tracking-[0.2em] uppercase text-white/40 mb-3">Mentions</div>
        <p className="text-white/50 text-sm leading-relaxed">
          Prix indicatifs en euros TTC. Chaque devis est ajusté selon la complexité et le volume.
        </p>
      </div>
    </div>
    <div className="border-t border-[#1E2D4A] py-5 text-center text-xs text-white/30">
      © {new Date().getFullYear()} {OWNER.name}. Tous droits réservés.
    </div>
  </footer>
);
